import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/feature/PageMeta";
import ContactForm from "@/pages/about/components/ContactForm";

const sections = [
  {
    icon: "ri-compass-3-line",
    title: "网站定位",
    body: "日韩在线是一个面向日韩影视爱好者的内容浏览平台。我们希望用清晰、整洁的方式，把最新日本与韩国电影、电视剧的信息集中呈现出来，让找片、追剧这件事变得更轻松。",
  },
  {
    icon: "ri-folder-open-line",
    title: "内容范围",
    body: "站内内容覆盖日本与韩国的电影与电视剧两大类，包含片名、原名、上映年份、地区、题材、主演、导演、剧情简介与站内热度等信息，并按年份与热门度持续更新整理。",
  },
  {
    icon: "ri-shield-check-line",
    title: "免责声明",
    body: "本站所有影视信息均为整理与演示用途，播放区域仅为前端展示示范，不接入任何真实播放接口，不托管、不存储、不提供任何影视资源或下载服务。如相关权利人认为内容存在不当之处，欢迎通过下方方式联系我们处理。",
  },
];

export default function AboutPage() {
  return (
    <>
      <PageMeta
        title="关于我们 -日韩在线"
        description="日韩在线是面向日韩影视爱好者的内容浏览平台，提供最新日韩电影电视剧信息整理与浏览服务。本站播放区域仅为前端演示，不提供真实播放与下载。"
        keywords="关于日韩在线,日韩影视平台,日韩电影电视剧,免责声明,联系我们"
      />
      <SiteLayout topOffset>
        <section className="relative w-full overflow-hidden bg-primary-950">
          <div className="absolute inset-0 opacity-25">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20dark%20navy%20blue%20background%20with%20soft%20amber%20light%20waves%20and%20subtle%20cinematic%20film%20grain%2C%20minimal%20artistic%20texture%2C%20wide%20banner%20composition&width=1920&height=560&seq=jk-about-header-01&orientation=landscape"
              alt="关于日韩在线"
              title="关于日韩在线 影视内容平台"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative w-full px-4 md:px-8 py-12 md:py-16">
            <nav className="flex items-center gap-1.5 text-xs text-background-200/70 flex-wrap" aria-label="面包屑">
              <Link to="/" className="hover:text-background-50 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center" />
              <span className="text-background-50">关于我们</span>
            </nav>
            <h1 className="mt-5 font-heading text-2xl md:text-4xl font-black text-background-50 tracking-tight">
              关于我们
            </h1>
            <p className="mt-3 max-w-2xl text-sm text-background-200/80 leading-relaxed">
              一个专注日韩影视信息整理与浏览的轻量平台，让每一次找片都简单直接。
            </p>
            <div className="mt-6 flex items-center gap-2 flex-wrap">
              <Link
                to="/category/movie"
                className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-accent-500 text-background-50 text-xs font-label font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors"
              >
                浏览日韩电影
              </Link>
              <Link
                to="/category/drama"
                className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md border border-background-50/25 text-background-50 text-xs font-label font-semibold whitespace-nowrap hover:bg-background-50/10 transition-colors"
              >
                浏览日韩电视剧
              </Link>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-10 md:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
            <div className="lg:col-span-7 flex flex-col gap-4">
              {sections.map((section) => (
                <article
                  key={section.title}
                  className="rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-6"
                >
                  <div className="flex items-start gap-3.5">
                    <span className="shrink-0 w-10 h-10 rounded-md bg-primary-50 text-primary-600 border border-primary-100 flex items-center justify-center">
                      <i className={`${section.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                    </span>
                    <div>
                      <h2 className="font-heading text-base md:text-lg font-bold text-foreground-950">{section.title}</h2>
                      <p className="mt-2 text-sm text-foreground-700 leading-[1.9]">{section.body}</p>
                    </div>
                  </div>
                </article>
              ))}

              <div className="rounded-lg bg-primary-950 p-5 md:p-6">
                <h2 className="font-heading text-base font-bold text-background-50">联系我们</h2>
                <ul className="mt-3 space-y-2.5 text-sm">
                  <li className="flex items-center gap-2.5 text-background-200/85">
                    <i className="ri-mail-line text-accent-400 w-4 h-4 flex items-center justify-center" />
                    反馈邮箱：feedback@example-jk.example
                  </li>
                  <li className="flex items-center gap-2.5 text-background-200/85">
                    <i className="ri-time-line text-accent-400 w-4 h-4 flex items-center justify-center" />
                    处理时间：工作日 10:00 - 18:00 内回复
                  </li>
                  <li className="flex items-start gap-2.5 text-background-200/70 text-xs leading-relaxed">
                    <i className="ri-information-line text-accent-400 w-4 h-4 flex items-center justify-center shrink-0 mt-0.5" />
                    以上邮箱为演示地址，实际反馈请使用右侧留言表单。
                  </li>
                </ul>
              </div>
            </div>

            <div className="lg:col-span-5">
              <ContactForm />
              <div className="mt-4 rounded-lg bg-background-100 border border-background-200/70 p-5">
                <h3 className="font-heading text-sm font-bold text-foreground-950">数据说明</h3>
                <ul className="mt-3 space-y-2.5 text-xs text-foreground-600 leading-relaxed">
                  <li className="flex gap-2">
                    <i className="ri-checkbox-blank-circle-fill text-[5px] text-accent-500 mt-1.5 w-2 h-2 flex items-center justify-center" />
                    站内影视信息为演示数据，用于展示浏览与筛选效果。
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-blank-circle-fill text-[5px] text-accent-500 mt-1.5 w-2 h-2 flex items-center justify-center" />
                    收藏记录仅保存在你的浏览器本地，不会上传服务器。
                  </li>
                  <li className="flex gap-2">
                    <i className="ri-checkbox-blank-circle-fill text-[5px] text-accent-500 mt-1.5 w-2 h-2 flex items-center justify-center" />
                    所有播放、选集、全屏按钮均为演示提示，无真实接口。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </SiteLayout>
    </>
  );
}